import { useState } from "#imports";

/**
 * How many `SideModal`s are on screen, so what floats over the page — the Copilote button — can
 * stand down for them.
 *
 * A count rather than a flag: side modals stack (a session detail's edit panel over the alert
 * centre), and the first one to close must not clear a state the second still needs.
 */
export function useSideModals() {
  const openSideModals = useState<number>("side_modals_open", () => 0);

  const hasOpenSideModal = computed<boolean>(() => openSideModals.value > 0);

  /** Counts the calling component in for as long as it is mounted. Call it from `<script setup>`. */
  function registerSideModal() {
    onMounted(() => openSideModals.value++);
    onUnmounted(() => openSideModals.value--);
  }

  return { hasOpenSideModal, registerSideModal };
}
